<template>
  <div>
    <div class="tabular-header custom-grid-activeorders">
      <div>ID</div>
      <div>Type</div>
      <div>Price</div>
      <div>Strategy</div>
      <div>Status</div>
      <div>Qty</div>
      <div>Price Ref</div>
    </div>
    <div class="active-orders scrollable">
      <div v-for="order in sellOrders" :key="order.clientID" class="tabular-row custom-grid-activeorders">
        <div>{{ order.clientID }}</div>
        <div :class="['order-side', 'order-' + order.side]">{{ order.side }}</div>
        <div class="order-price">{{ order.price }}</div>
        <div><span :class="['bucket-badge', 'bucket-' + order.strategy]">{{ order.strategy }}</span></div>
        <div><span :class="['status-badge', 'status-' + order.status]">{{ order.status }}</span></div>
        <div :class="['qty-cell', order.side === 'buy' ? 'qty-buy' : 'qty-sell']">{{ order.qty }}</div>
        <div class="pl-10 order-price">{{ order.priceRef }}</div>
      </div>
      <!-- Linha do spread -->
      <div class="spread-row" v-if="buyOrders.length || sellOrders.length">
        Spread: {{ spread.value }} ({{ spread.percent }}%)
      </div>
      <div v-for="order in buyOrders" :key="order.clientID" class="tabular-row custom-grid-activeorders">
        <div>{{ order.clientID }}</div>
        <div :class="['order-side', 'order-' + order.side]">{{ order.side }}</div>
        <div class="order-price">{{ order.price }}</div>
        <div><span :class="['bucket-badge', 'bucket-' + order.strategy]">{{ order.strategy }}</span></div>
        <div><span :class="['status-badge', 'status-' + order.status]">{{ order.status }}</span></div>
        <div :class="['qty-cell', order.side === 'buy' ? 'qty-buy' : 'qty-sell']">{{ order.qty }}</div>
        <div class="pl-10 order-price">{{ order.priceRef }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {formatDate} from '../utils/funcs.js'

export default {
  name: "activeOrders",
  computed: {
    ...mapState({
        orders: state => (state && state.orders) ? state.orders : {},
        marketData: state => state.marketData,
    }),
    buyOrders() {
      return Object.values(this.orders).filter(order => order.side === 'buy').sort((a, b) => b.price - a.price);
    },

    sellOrders() {
      return Object.values(this.orders).filter(order => order.side === 'sell').sort((a, b) => b.price - a.price); // ✅ Reversed (Maior → Menor) - melhor que usar o reverse() depois do sort
    },
    spread() {
      const bestBuy = this.buyOrders.length ? this.buyOrders[0].price : null;
      const bestSell = this.sellOrders.length ? this.sellOrders[this.sellOrders.length - 1].price : null;
      const currentPrice = this.marketData.btcUsd;
      let value = 0, denom = 1;

      if (bestBuy !== null && bestSell !== null) {
        value = bestSell - bestBuy;
        denom = bestBuy;
      } else if (bestBuy !== null) {
        value = currentPrice - bestBuy;
        denom = bestBuy;
      } else if (bestSell !== null) {
        value = bestSell - currentPrice;
        denom = currentPrice;
      } else {
        return { value: '0.00', percent: '0.00' };
      }

      // Garante que denominador é positivo e não zero
      const percent = denom > 0 ? ((value / denom) * 100) : 0;

      return {
        value: value.toFixed(2),
        percent: percent.toFixed(2)
      };
    }
  },
  methods: {
    formatDate
  },
};
</script>

<style>

.active-orders {
  background-color: var(--table-header-bgcolor);
  color: var(--text-color);
  border-radius: 10px;
  height: 362px;
  display: flex;
  flex-direction: column;
}
.spread-row {
  text-align: center;
  font-weight: bold;
  background-color: var(--table-header-bgcolor);
  color: var('--text-color');
  padding: 6px 0;
  border: 1px solid #333;
}

.custom-grid-activeorders {
  display: grid;
  grid-template-columns: 2fr 1fr 0.7fr 0.6fr 0.6fr 1fr 0.7fr !important;
}

.order-price {
  font-size: 1rem;
}

</style>
